import { render, staticRenderFns } from "./medicineBook.vue?vue&type=template&id=0083268a&scoped=true&"
import script from "./medicineBook.vue?vue&type=script&lang=js&"
export * from "./medicineBook.vue?vue&type=script&lang=js&"
import style0 from "./medicineBook.vue?vue&type=style&index=0&id=0083268a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083268a",
  null
  
)

export default component.exports